(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dicomMicroscopyViewer", [], factory);
	else if(typeof exports === 'object')
		exports["dicomMicroscopyViewer"] = factory();
	else
		root["dicomMicroscopyViewer"] = factory();
})(this, function() {
return 